import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import TonnageApi, { GetTonnageByIdParam } from '../api/TonnageApi';
import BaseResponse from '../../../app/BaseResponse';
import Utility from '../../../app/utility';
import TonnageOperatorHistoryModel from '../models/TonnageOperatorHistory';
import { Modal } from '@mui/material';
import { setModalOpen, setTonnageHistories, tonnageOperatorHistoryModalSelector } from '../reducers/TonnageOperatorHistoryReducer';
import { showLoading } from '../../LoadingView/reducers/LoadingViewReducer';
import Datatable, { PagingTypeEnum } from '../../Datatable/Datatable';
import DatatableColumnModel, { DatatableColumnAlign } from '../../Datatable/DatatableColumnModel';

const TonnageOperatorHistoryModal: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const tonnageOperatorModal = useSelector(tonnageOperatorHistoryModalSelector);

    useEffect(() => {
        if (tonnageOperatorModal.open &&
            tonnageOperatorModal.tonnageId &&
            tonnageOperatorModal.tonnageId.length > 0 &&
            tonnageOperatorModal.operatorHistories.length == 0) {
            dispatch(showLoading(true));
            getOperatorHistory(tonnageOperatorModal.tonnageId);
        }
    }, [tonnageOperatorModal.open])

    const datatableCollumnConfig = [
        {
            Field: "updatedDate",
            Title: "Updated Date",
            Align: DatatableColumnAlign.Left,
            Render: (rowData: TonnageOperatorHistoryModel) => (
                <>
                    {Utility.DateFormat.format(rowData.updatedDate)}
                </>
            )
        } as DatatableColumnModel<TonnageOperatorHistoryModel>,
        {
            Field: "operatorName",
            Title: "Operator",
            Align: DatatableColumnAlign.Left,
        } as DatatableColumnModel<TonnageOperatorHistoryModel>,
    ];

    const getOperatorHistory = (tonnageId: string) => {
        TonnageApi.GetOperatorHistory({ id: tonnageId } as GetTonnageByIdParam)
            .then((response: BaseResponse<TonnageOperatorHistoryModel[]>) => {
                if (response.success) {
                    dispatch(setModalOpen(true));
                    dispatch(setTonnageHistories(response.data));
                } else {
                    Utility.Alert.Error(response.message);
                }
            })
            .catch((error) => {
                Utility.Alert.Error(error);
            })
            .finally(() => {
                dispatch(showLoading(false));
            });
    }

    return (
        <>
            <Modal
                open={tonnageOperatorModal.open}
                onClose={() => {
                    dispatch(setModalOpen(false));
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Datatable<TonnageOperatorHistoryModel>
                    className="tonnage-operator-table"
                    useDefaultSearchBar={false}
                    useItemPerPage={false}
                    pagingType={PagingTypeEnum.None}
                    columns={datatableCollumnConfig}
                    data={tonnageOperatorModal.operatorHistories}
                    isDataLoaded={true}
                ></Datatable>
            </Modal>
        </>
    )
};

export default TonnageOperatorHistoryModal;